// extracted by mini-css-extract-plugin
export default {"button":"tooltip_btn_button__I9KD+","tooltip":"tooltip_btn_tooltip__Vqog-"};